<template>
  <div>
    <template v-if="!$route.meta.allowAnonymous">
      <v-app id="inspire">
        <div class="app-container">
          <toolbar @toggleNavigationBar="drawer = !drawer"/>
          <navigation :toggle="drawer"/>
          <v-content>
            <breadcrumbs />
            <router-view/>
            <page-footer />
          </v-content>
        </div>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      drawer: true
    }
  }
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Mitr:wght@200&display=swap');

  .v-btn:hover:before{
    color: transparent !important;
  }

html, body {
  font-family: 'Mitr', sans-serif;
}

#app {
  font-family: 'Mitr', sans-serif;
}

</style>



// WEBPACK FOOTER //
// src/App.vue